import { Button, Box, Typography } from "@mui/material";
import {useAuth} from "../../auth/context";

const LandingPatientSelfRegister = ({
  setCheckEnterData,
  user
}) => {
    const fromDoctorByTitleLanding = user?.patientsDisplayNames()?.title;
    const titleLandingRegister = `${fromDoctorByTitleLanding} solicita sus datos`;

    return (
    <>
      <Box
        sx={{
          background:
            "linear-gradient(90deg, #86B1D0 0%, #3887BE 50%, #2E5F81 100%)",
          width: 60,
          height: 60,
          borderRadius: "50%",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 4,
          p: "2px",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            background: "white",
            borderRadius: "50%",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            width={"35px"}
            src={"/icon-landing-self-register.png"}
            alt="icon-landing-self-registe"
          />
        </Box>
      </Box>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: 18, md: 20 },
          fontFamily: `"Inter", sans-serif`,
          color: "#202224",
          p: 1,
        }}
      >
        {titleLandingRegister}
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          fontFamily: `"Inter", sans-serif`,
          color: "text.black",
          minWidth: { xs: "auto", sm: 200 },
          maxWidth: { xs: "auto", sm: 480 },
          p: 1,
          mt: 3,
        }}
      >
        Su Dr/a. necesita que complete sus datos para poder enviarle las ordenes
        y recetas médicas de manera mas ágil y personalizada.
      </Typography>

      <Button
        variant="contained"
        onClick={() => setCheckEnterData(true)}
        sx={{ mt: 4 }}
      >
        Ingresar mis datos
      </Button>
    </>
  );
};

export default LandingPatientSelfRegister;
